import { api } from '../client';

export const connectors = {
  list: api.listConnectors,
  listForGi: api.listConnectorsForGi,
  get: api.getConnector,
  create: api.createConnector,
  update: api.updateConnector,
  remove: api.deleteConnector,
  test: api.testConnector,
  reset: api.resetConnectors,
};
